import React from "react";
import { Badge } from "../../../../components/ui/badge";
import { useLocation, Link } from "react-router-dom";
import { cn, isLocationMatch } from "../../../../helper/utilityHelper";
import PremiumIcon from "../../../../components/partials/sidebar/classic/Premium-Icon";
import NewTag from "../common/NewTag";
const SingleMenuItem = ({ item, collapsed }) => {
    const { badge, href, title, isPremium, isNew } = item;
  const location = useLocation();
  const locationName = location.pathname;

  return (
    <Link to={href}>
      <>
        {collapsed ? (
          <div>
            <span
              className={cn(
                "h-12 w-12 mx-auto rounded-md  transition-all duration-300 inline-flex flex-col items-center justify-center  relative  ",
                {
                  "bg-primary text-primary-foreground ": isLocationMatch(
                    href,
                    locationName
                  ),
                  " text-default-600  ": !isLocationMatch(href, locationName),
                }
              )}
            >
              <item.icon className="w-6 h-6" />
            </span>
          </div>
        ) : (
          <div
            className={cn(
              "flex gap-3  text-default-700 text-sm capitalize px-[10px] py-3 rounded cursor-pointer hover:bg-primary hover:text-primary-foreground",
              {
                "bg-primary text-primary-foreground": isLocationMatch(
                  href,
                  locationName
                ),
              }
            )}
          >
            <span className="flex-grow-0">
              <item.icon className="w-5 h-5" />
            </span>
                          <div className="text-box flex-grow">{title}</div>
                          {isNew && <NewTag className="rounded-full ml-2" />}
                          {isPremium && <div className="flex items-center justify-center w-3 h-3"><PremiumIcon /></div>}
            {badge && <Badge className=" rounded">{item.badge}</Badge>}
          </div>
        )}
      </>
    </Link>
  );
};

export default SingleMenuItem;
